import React, { useState, useEffect } from "react";
import api from "../../Components/API/Api";
import classes from './Receivables.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation } from 'react-router-dom';
import { Eye, Edit, Trash } from 'lucide-react';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import mail from "../../Assets/mail.png";
import call from "../../Assets/call.png";
import Footer from "../../Components/Footer/Footer";
import { useNavigate } from "react-router-dom";

const Receivables = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchReceivables = async () => {
            try {
                const response = await api.get(`/v1/all_receivables`);
                const result = Array.isArray(response.data?.data?.data) ? response.data.data.data : [];
                setData(result);
            } catch (error) {
                setData([]);
                console.error("Error fetching receivables:", error);
            }
        };

        fetchReceivables();
    }, []);

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />
            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button
                        className={classes.btns}
                        onClick={() => navigate("/transactions/sales-invoice/sale")}
                    >
                        Sales Invoice
                    </button>
                    <button className={classes.btns} onClick={() => navigate("/inventory/purchaseOrder")}> Purchase Order</button>
                    <button
                        className={classes.btns}
                        style={{ backgroundColor: '#16A34A', color: 'white' }}
                    >
                        Receivables
                    </button>
                    <button onClick={() => navigate('/settings/product-services')} className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div>

                <header className={classes.Header}>
                    <div>
                        <h2 className={classes.Title}>Receivables</h2>
                        <h1 className={classes.Titles}>
                            Manage your purchase transactions, supplier invoices, and payments.
                        </h1>
                    </div>


                    <div className={classes.thrdkad}>
                        <div className={classes.kad}>
                            <p className={classes.kdptg}>Total Outstanding</p>
                            <p className={classes.kdptg1}>₦8,400,000.00</p>
                            <div className={classes.rvnue}>
                                <p className={classes.skaltxt}>All Receivables</p>
                            </div>
                        </div>
                    </div>
                </header>

                <div className={classes.entrjj}>
                    <div className={classes.allkads}>

                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Current(0-30 days)</p>
                                <p className={classes.kdptg2}>₦4,950,000.00</p>
                                {/* <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Not yet due</p>
                                </div> */}
                            </div>
                        </div>
                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>1-30 days Overdue</p>
                                <p className={classes.kdptg3}>₦3,200,000.00</p>
                                {/* <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Recently Overdue</p>
                                </div> */}
                            </div>
                        </div>
                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>31-60 Days Overdue</p>
                                <p className={classes.kdptg4}>15</p>
                                {/* <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Moderate Risk</p>
                                </div> */}
                            </div>
                        </div>

                        <div className={classes.secondkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>60+ Days Overdue</p>
                                <p className={classes.kdptg4}>15</p>
                                {/* <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>High Risk</p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>

                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                            <input type="text" className={classes.searchBar} placeholder="Search sales" />
                        </div>


                        <div className={classes.selectWrapper}>
                            <select className={classes.dropdown}>
                                <option value="">All Methods</option>
                                <option value="Paid">Paid</option>
                                <option value="Pending">Pending</option>
                                <option value="Overdue">Overdue</option>
                                <option value="Draft">Draft</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div>

                        <div className={classes.inputWrapper}>
                            <input type="text" className={classes.searchBars} placeholder="Filter..." />
                            <img src={filter} alt="Filter" className={classes.inputIcon} />
                        </div>
                    </div>
                    <div className={classes.btnsMain}>
                        <button className={classes.btnssWhite}> <img src={mail} alt="" /> Send Reminder</button>
                        <button className={classes.btnss}> + Record Payments</button>
                    </div>

                </div>

                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr className={classes.tableHeader}>
                                <th>S/N</th>
                                <th>Customer Name</th>
                                <th style={{ width: "140px" }}>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(Array.isArray(data) ? data : []).map((row, index) => (
                                <tr key={index} className={classes.tableRow}>
                                    <td className={classes.tableCell}>{index + 1}</td>
                                    <td className={classes.tableCell}>{row.name}</td>
                                    <td className={classes.tableCell3} style={{ width: "140px" }}>
                                        {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(Number(row.balance))}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td>First</td>
                            <td className={`${classes.page} ${classes.activePage}`}>1</td>
                            <td className={classes.page}>2</td>
                            <td>Last</td>
                        </tr>
                        <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div>

                    </tfoot>

                </table>
            </div>
            <Footer />
        </div>
    );
};

// export default Receivables;
//                 <table className={classes.footerTable}>
//                     <tfoot>
//                         <tr>
//                             <td>First</td>
//                             <td className={`${classes.page} ${classes.activePage}`}>1</td>
//                             <td className={classes.page}>2</td>
//                             <td>Last</td>
//                         </tr>
//                         <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div>

//                     </tfoot>

//                 </table>
//             </div>
//             <Footer />

//         </div>
//     );
// };

export default Receivables;
